import { Map } from "lucide-react";

import { SECTION_TYPES } from "@/lib/constants/sections";

import type { ServiceSection } from "@/types/sections";

const ppcServiceAreasSection: ServiceSection = {
  type: SECTION_TYPES.PPC_SERVICE_AREAS,
  content: {
    header: "Areas We Serve",
    bgImage: {
      alt: "",
      providerId: "",
      source: "",
      url: "https://images.unsplash.com/photo-1592595896551-12b371d546d5?q=60&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3",
    },
  },
  meta: {
    displayName: "Service Areas PPC",
    displayDescription: "Show your customers where you operate.",
    displayIcon: Map,
  },
};

export default ppcServiceAreasSection;
